import React from 'react';
import OrderItemsTable from './OrderItemsTable';
import VoucherTable from './VoucherTable';
// import VoucherTable from "./VoucherTable"

function Tables(props) {
  const { children } = props;
  return <div>{children}</div>;
}

Tables.VoucherTable = VoucherTable;
Tables.OrderItems = OrderItemsTable;



export default Tables;
